// extracted by mini-css-extract-plugin
export default {"brandProduct":"ProductSlider_brandProduct__ewYg+","brandHeader":"ProductSlider_brandHeader__0NA6s"};